const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

class FinancialService {
    constructor() {
        this.token = localStorage.getItem('auth_token') || localStorage.getItem('auth_token');
    }

    getHeaders() {
        return {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.token}`,
        };
    }

    updateToken() {
        this.token = localStorage.getItem('auth_token') || localStorage.getItem('auth_token');
    }

    // Улучшенная обработка ответов
    async handleResponse(response) {
        const data = await response.json();

        // Всегда возвращаем данные, даже при ошибках
        // Это позволяет фронтенду обрабатывать детализированные ошибки
        return data;
    }

    async getBalances() {
        this.updateToken();
        try {
            const response = await fetch(`${API_BASE_URL}/financial/balances`, {
                headers: this.getHeaders(),
            });
            return await this.handleResponse(response);
        } catch (error) {
            console.error('Balances fetch error:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером'
            };
        }
    }

    async getOperations(params = {}) {
        this.updateToken();

        try {
            const queryParams = new URLSearchParams({
                page: params.page || 1,
                per_page: params.per_page || 10,
            });

            if (params.search) queryParams.append('search', params.search);
            if (params.status && params.status !== 'all') queryParams.append('status', params.status);
            if (params.type && params.type !== 'all') queryParams.append('type', params.type);

            const response = await fetch(`${API_BASE_URL}/financial/operations?${queryParams}`, {
                headers: this.getHeaders(),
            });

            return await this.handleResponse(response);
        } catch (error) {
            console.error('Operations fetch error:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером'
            };
        }
    }

    async createDeposit(data) {
        this.updateToken();

        try {
            const response = await fetch(`${API_BASE_URL}/financial/deposit`, {
                method: 'POST',
                headers: this.getHeaders(),
                body: JSON.stringify(data),
            });

            return await this.handleResponse(response);
        } catch (error) {
            console.error('Deposit creation error:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером'
            };
        }
    }

    /**
     * 🆕 Создать депозит через NOWPayments
     * Пользователь вводит сумму на стороне платежной системы
     */
    async createDepositNowPayments(data) {
        this.updateToken();

        try {
            const response = await fetch(`${API_BASE_URL}/financial/deposit/nowpayments`, {
                method: 'POST',
                headers: this.getHeaders(),
                body: JSON.stringify({
                    amount: parseFloat(data.amount || 10),
                }),
            });

            return await this.handleResponse(response);
        } catch (error) {
            console.error('NOWPayments deposit creation error:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером'
            };
        }
    }

    /**
     * 🆕 Получить статус платежа NOWPayments
     */
    async getNowPaymentStatus(paymentId) {
        this.updateToken();

        try {
            const response = await fetch(`${API_BASE_URL}/financial/nowpayments/status/${paymentId}`, {
                headers: this.getHeaders(),
            });

            return await this.handleResponse(response);
        } catch (error) {
            console.error('NOWPayments status check error:', error);
            return {
                success: false,
                message: 'Ошибка проверки статуса'
            };
        }
    }

    async createTransfer(data) {
        this.updateToken();

        try {
            const response = await fetch(`${API_BASE_URL}/financial/transfer`, {
                method: 'POST',
                headers: this.getHeaders(),
                body: JSON.stringify(data),
            });

            return await this.handleResponse(response);
        } catch (error) {
            console.error('Transfer creation error:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером'
            };
        }
    }

    async createWithdraw(data) {
        this.updateToken();

        try {
            const response = await fetch(`${API_BASE_URL}/financial/withdraw`, {
                method: 'POST',
                headers: this.getHeaders(),
                body: JSON.stringify(data),
            });

            return await this.handleResponse(response);
        } catch (error) {
            console.error('Withdraw creation error:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером'
            };
        }
    }

    async confirmOperation(data) {
        this.updateToken();

        try {
            const response = await fetch(`${API_BASE_URL}/financial/confirm`, {
                method: 'POST',
                headers: this.getHeaders(),
                body: JSON.stringify(data),
            });

            return await this.handleResponse(response);
        } catch (error) {
            console.error('Operation confirmation error:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером'
            };
        }
    }

    async cancelOperation(data) {
        this.updateToken();

        try {
            const response = await fetch(`${API_BASE_URL}/financial/cancel`, {
                method: 'POST',
                headers: this.getHeaders(),
                body: JSON.stringify(data),
            });

            return await this.handleResponse(response);
        } catch (error) {
            console.error('Operation cancellation error:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером'
            };
        }
    }
}

export const financialService = new FinancialService();
